import BaseDocument from '../../Model/BaseDocument';
import Collections from '../../utils/collections';

class MealPlanCreationRequest extends BaseDocument {
  constructor(id, opts) {
    super(`${Collections.MEAL_PLAN_CREATION_REQUEST}/${id}`, opts);
  }

  get status() {
    return this.data.status;
  }

  get recipes() {
    return this.data.recipes;
  }

  get images() {
    return this.data.images;
  }

  get mealBreakdown() {
    return this.data.mealBreakdown;
  }

  static async getMealPlanCreationRequest(mealPlanCreationRequestId) {
    const mealPlanCreationRequestDoc = new MealPlanCreationRequest(mealPlanCreationRequestId);
    await mealPlanCreationRequestDoc.init();
    return mealPlanCreationRequestDoc.exists ? mealPlanCreationRequestDoc : null;
  }
}

export default MealPlanCreationRequest;
